// extracted by mini-css-extract-plugin
export default {"block":"styles_block__RUdie","dropdown":"styles_dropdown__11bAJ"};